module.exports = __webpack_public_path__ + "img/vertical_2_1_6005.a95151b2.png";